import axios from "axios";
import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import theme from "../styles/theme";
import { PillarType } from "../types/Roadmap";
import Button from "./Button";
import FlexBox, { FlexGrow } from "./FlexBox";
import MinimalSelect from "./MinimalSelect";
import { StyledText, TextSize, TextStatus } from "./Text";
import { Icon as MuiIcon } from "@mui/material";
import { components } from "react-select";
import Icon, { ClickableIcon } from "./Icon";
import FlexCard from "./FlexCard";
import Status from "../types/enum/Status";
import NewCompButtonGroup from "./NewCompButtonGroup";
import { VersionContext } from "../context/VersionContext";

const { Option, SingleValue } = components;
const IconOption = (props: any) => (
  <Option {...props}>
    <MuiIcon
      sx={{
        mr: 1,
        padding: "4px",
        background: props.data.graphics.iconbg,
        boxShadow: props.data.graphics.iconshadow,
        borderRadius: "100px",
        verticalAlign: "bottom",
        fontSize: "14px",
      }}
    >
      {props.data.graphics.icon}
    </MuiIcon>
    {props.data.label}
  </Option>
);
const CustomSingleValue = (props: any) => {
  return (
    <SingleValue {...props}>
      <MuiIcon
        sx={{
          mr: 1,
          padding: "4px",
          background: props.data.graphics.iconbg,
          boxShadow: props.data.graphics.iconshadow,
          borderRadius: "100px",
          fontSize: "14px",
          verticalAlign: "sub",
        }}
      >
        {props.data.graphics.icon}
      </MuiIcon>
      <span className="react-select__single-value">
        {props.selectProps.getOptionLabel(props.data)}
      </span>
    </SingleValue>
  );
};
export const CustomFlexFixed = styled(FlexBox)`
  width: 100%;
  position: fixed;
  bottom: 0;
  right: 0px;
  background: #ffffff;
  padding: 6px 0px;
  box-shadow: 0 75px 45px 45px black;
  // z-index: 9999;
`;
const CustomFlexPlain = styled(FlexBox)`
  padding: 20px 0;
  align-items: center;
`;
const CustomGrowPlain = styled(FlexGrow)`
  flex-grow: 1;
  width: 100%;
  text-align: center;
`;
const Label = styled.h5`
  text-transform: uppercase;
  color: ${theme.color.darkBlueGray800};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0px;
`;
const Header = styled.h4`
  text-align: center;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0px;
  color: ${theme.color.darkBlueGray900};
`;
type PillarCustomType = {
  label: string;
  value: string;
  selected: boolean;
  index: string;
  graphics: any;
  subdomains: Array<any>;
};
type DomainType = {
  label: string;
  value: string;
  knowledge_areas: Array<any>;
};
type KnowledgeType = {
  label: string;
  value: string;
};
type CreateCompetencySelectionType = {
  onNextClicked: (pillar?: any, domain?: any, knowledge?: any) => void;
};
const SaveButton = styled(Button)`
  background-color: ${({ theme }) => theme.color.blue500};
`;

function CreateCompetencySelection({
  onNextClicked,
}: CreateCompetencySelectionType) {
  const [pillars, setPillars] = useState<Array<PillarCustomType>>([]);
  const [domains, setDomains] = useState<Array<DomainType>>([]);
  const [knowledgeAreas, setKnowledgeAreas] = useState<Array<KnowledgeType>>(
    []
  );
  const [selectedPillar, setSelectedPillar] = useState<PillarCustomType>();
  const [selectedDomain, setSelectedDomain] = useState<DomainType>();
  const [selectedKnowledge, setSelectedKnowledge] = useState<KnowledgeType>();
  const [currentTab, setCurrentTab] = useState("new");
  useEffect(() => {
    fetchPillars();
  }, []);
  // useEffect(() => {
  //   if (selectedPillar) mapDomains(selectedPillar);
  // }, [selectedPillar]);
  useEffect(() => {
    if (selectedDomain) mapKnowledgeAreas(selectedDomain);
  }, [selectedDomain]);
  const fetchPillars = () => {
    axios
      .get("/pillar")
      .then((res) => {
        mapPillars(res.data.pillars);
      })
      .catch((err: any) => {
        if (err?.response?.data?.message === "missing or malformed jwt") {
          window.location.pathname = "/signin";
        }
      });
  };

  const mapPillars = (data: PillarType) => {
    const custom: Array<{
      label: string;
      value: string;
      prefix: string;
      selected: boolean;
      index: string;
      graphics: any;
      subdomains: Array<any>;
    }> = [];
    data.forEach((element: any) => {
      custom.push({
        value: element.id,
        label: element.title,
        prefix: element.prefix,
        selected: false,
        index: "",
        graphics: element.graphics,
        subdomains: element.subdomains,
      });
    });
    setPillars(custom);
  };
  // const mapDomains = (data: PillarCustomType) => {
  //   const custom: Array<{
  //     label: string;
  //     value: string;
  //     knowledge_areas: Array<any>;
  //   }> = [];
  //   data.subdomains.forEach((element: any) => {
  //     custom.push({
  //       value: element.id,
  //       label: element.title,
  //       knowledge_areas: element.knowledge_areas,
  //     });
  //   });
  //   setDomains(custom);
  // };
  const mapKnowledgeAreas = (data: DomainType) => {
    const custom: Array<{
      label: string;
      value: string;
    }> = [];
    data.knowledge_areas.forEach((element: any) => {
      custom.push({
        value: element.id,
        label: element.title,
      });
    });
    setKnowledgeAreas(custom);
  };

    const { version } = useContext(VersionContext);
  
  const onPillarChange = (e: any) => {
    setSelectedPillar(e);
    setSelectedDomain({
      label: "",
      value: "",
      knowledge_areas: [],
    });
    setSelectedKnowledge({ label: "", value: "" });
    const custom: Array<{
      label: string;
      value: string;
      knowledge_areas: any;
    }> = [];
    axios
      .get(`/subdomain/summary?pillar_id=${e.value}&curriculum_version=${version?.version_number}`)
      .then((res) => {
        res.data.subdomains.forEach((element: any) => {
          custom.push({
            value: element.id,
            label: element.title,
            knowledge_areas: [],
          });
        });
        setDomains(custom);
      })
      .catch(() => {});
  };
  const onDomainChange = (e: any) => {
    setSelectedDomain(e);
    setSelectedKnowledge({ label: "", value: "" });
    const custom: Array<{
      label: string;
      value: string;
      knowledge_areas: any;
    }> = [];
    axios
      .get(`/knowledgearea?subdomain_id=${e.value}`)
      .then((res) => {
        res.data.knowledgeareas.forEach((element: any) => {
          custom.push({
            value: element.id,
            label: element.title,
            knowledge_areas: [],
          });
        });
        setKnowledgeAreas(custom);
      })
      .catch(() => {});
  };

  return (
    <>
      <FlexCard
        height="calc(100vh - 62px)"
        direction="column"
        alignItems="start"
        className="visible-scrollbar"
        style={{ overflowX: "hidden" }}
      >
        <FlexBox
          direction="column"
          style={{
            width: "100%",
            padding: "16px 0px",
            // borderBottom: "0.8px solid #64748B",
          }}
          space={0}
        >
          <FlexGrow>
            <Header>Create New Competency</Header>
          </FlexGrow>
          <FlexGrow>
            <StyledText textSize={TextSize.small} style={{ color: "#64748B" }}>
              Follow steps to create a new competency
            </StyledText>
          </FlexGrow>
        </FlexBox>
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <div style={{ width: "100%", padding: 20 }}>
            {/* <NewCompButtonGroup
              tab={currentTab}
              handleChange={(value: string) => setCurrentTab(value)}
            /> */}
            {currentTab === "new" ? (
              <FlexBox
                style={{
                  // margin: "0px 20px 0px 20px",
                  width: "100%",
                  // padding: "16px 0px",
                  // border: "1px solid #eff4fb",
                  // minHeight: "30vh",
                  borderRadius: 5,
                  // marginTop: 5,
                  // boxShadow: "0 4px 4px #eff4fb",
                  // paddingBottom: 50,
                }}
              >
                <FlexGrow>
                  <CustomFlexPlain direction="column">
                    <CustomGrowPlain>
                      <Label>1. Choose Pillar</Label>
                    </CustomGrowPlain>
                    <CustomGrowPlain>
                      <MinimalSelect
                        menuPortalTarget={document.body}
                        placeholder="Choose pillar..."
                        onChange={(e: any) => {
                          onPillarChange(e);
                        }}
                        styles={{
                          placeholder: (base) => ({
                            ...base,
                            fontSize: "12px",
                            textAlign: "left",
                          }),
                          menuList: (base) => ({
                            ...base,
                            maxHeight: "430px",
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                            color: theme.color.lightBlueGray800,
                          }),
                        }}
                        options={pillars}
                        components={{
                          Option: IconOption,
                          // ValueContainer: ValueContainerLabel,
                          SingleValue: CustomSingleValue,
                        }}
                      />
                    </CustomGrowPlain>
                  </CustomFlexPlain>
                </FlexGrow>
                <FlexGrow>
                  <CustomFlexPlain direction="column">
                    <CustomGrowPlain>
                      <Label>2. Choose subdomain</Label>
                    </CustomGrowPlain>
                    <CustomGrowPlain>
                      <MinimalSelect
                        menuPortalTarget={document.body}
                        value={
                          selectedDomain && selectedDomain.value !== ""
                            ? domains.find(
                                (v) => v.value === selectedDomain.value
                              )
                            : ""
                        }
                        placeholder="Choose subdomain..."
                        onChange={(e: any) => {
                          onDomainChange(e);
                        }}
                        styles={{
                          placeholder: (base) => ({
                            ...base,
                            fontSize: "12px",
                            textAlign: "left",
                          }),
                          menuList: (base) => ({
                            ...base,
                            maxHeight: "430px",
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                            color: theme.color.lightBlueGray800,
                          }),
                        }}
                        options={domains}
                      />
                    </CustomGrowPlain>
                  </CustomFlexPlain>
                </FlexGrow>
                <FlexGrow>
                  <CustomFlexPlain direction="column">
                    <CustomGrowPlain>
                      <Label>3. Choose knowledge area</Label>
                    </CustomGrowPlain>
                    <CustomGrowPlain>
                      <MinimalSelect
                        value={
                          selectedKnowledge && selectedKnowledge.value !== ""
                            ? knowledgeAreas.find(
                                (v) => v.value === selectedKnowledge.value
                              )
                            : ""
                        }
                        menuPortalTarget={document.body}
                        onChange={(e: any) => {
                          setSelectedKnowledge(e);
                        }}
                        placeholder="Choose knowledge area..."
                        styles={{
                          placeholder: (base) => ({
                            ...base,
                            fontSize: "12px",
                            textAlign: "left",
                          }),
                          menuList: (base) => ({
                            ...base,
                            maxHeight: "430px",
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                            color: theme.color.lightBlueGray800,
                          }),
                        }}
                        options={knowledgeAreas}
                      />
                    </CustomGrowPlain>
                  </CustomFlexPlain>
                </FlexGrow>
              </FlexBox>
            ) : (
              <FlexBox
                style={{
                  // margin: "0px 20px 0px 20px",
                  width: "100%",
                  // padding: "16px 0px",
                  border: "1px solid #eff4fb",
                  minHeight: "30vh",
                  borderRadius: 5,
                  marginTop: 5,
                  boxShadow: "0 4px 4px #eff4fb",
                  paddingBottom: 50,
                }}
              >
                <FlexGrow>
                  
                </FlexGrow>
              </FlexBox>
            )}
          </div>
        </div>

        <CustomFlexFixed>
          <FlexGrow
            style={{
              textAlign: "end",
              marginRight: "30px",
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            <SaveButton
              className="reduce_opct_onhover"
              style={{
                background: theme.color.blueButton,
                boxShadow: "0 2px 5px #808080cc",
                border: "none",
                width: 120,
                minHeight: 40,
              }}
              key={0}
              disabled={
                !(
                  selectedPillar &&
                  selectedDomain?.value !== "" &&
                  selectedKnowledge?.value !== ""
                )
              }
              type="button"
              onClick={() => {
                onNextClicked(
                  selectedPillar,
                  selectedDomain,
                  selectedKnowledge
                );
              }}
              status={Status.primary}
              isOutline={false}
            >
              Next
              <Icon
                style={{ paddingLeft: "8px" }}
                name={"arrow_circle_right"}
              />
            </SaveButton>
          </FlexGrow>
        </CustomFlexFixed>
      </FlexCard>
    </>
  );
}
export default CreateCompetencySelection;
